import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyFieldSelectProps, FormlySelectModule } from '@ngx-formly/core/select';
import { MultiSelect } from '@openng/optimus-ui/multiselect';
import { SelectSearchTextPipe } from '../../../pipes';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface MultiSelectProps extends FieldWrapperProps, FormlyFieldSelectProps {
  virtualScroll?: boolean;
  virtualScrollSize?: number;
  showClear?: boolean;
  groupLabelProp?: string;
  groupChildrenProp?: string;
  searchByValue?: boolean;

  optionLabel?: string;
  optionValue?: string;

  scrollHeight?: string;
}

export interface MultiSelectFieldConfig extends FormlyFieldConfig<MultiSelectProps> {
  type?: 'multi-select' | Type<MultiSelectTypeComponent>;
}

@Component({
  selector: 'lib-formly-multi-select-type',
  templateUrl: './multi-select-type.component.html',
  styleUrl: './multi-select-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslocoDirective,
    MultiSelect,
    ReactiveFormsModule,
    FormlyModule,
    NgClass,
    AsyncPipe,
    FormlySelectModule,
    SelectSearchTextPipe
  ]
})
export class MultiSelectTypeComponent extends FieldType<FieldTypeConfig<MultiSelectProps>> {}
